"use client"

import { datadog } from "@/platform/observability/datadog/facade"

import { trackEvent } from "./track"

import type {
  SignupFlowStartEvent,
  SignupFlowPageViewEvent,
  SignupSuccessEvent,
  SignupEntryClickEvent,
  InlineSignupDecisionEvent,
  InlineSignupSheetClosedEvent,
  VerificationCodeResendCompletedEvent,
  VerificationCodeResendClickedEvent,
  VerificationCodeResendFlowStartedEvent,
} from "./types/custom"
import type { SignUpEvent, LoginEvent } from "./types/google"

export function trackSignup(params: SignUpEvent["params"]): void {
  trackEvent("sign_up", params)
}

export function trackLogin(params: LoginEvent["params"]): void {
  trackEvent("login", params)
}

export function trackSignupFlowStart(params: SignupFlowStartEvent["params"]): void {
  trackEvent("signup_flow_start", params)
}

export function trackSignupStepView(params: SignupFlowPageViewEvent["params"]): void {
  trackEvent("signup_flow_page_view", params)
  datadog.addAction(`signup.${params.step}`, params)
}

export function trackSignupSuccess(params: SignupSuccessEvent["params"]): void {
  trackEvent("signup_success", params)
}

export function trackSignupEntryClick(params: SignupEntryClickEvent["params"]): void {
  trackEvent("signup_entry_click", params)
}

export function trackInlineSignupDecision(params: InlineSignupDecisionEvent["params"]): void {
  trackEvent("inline_signup_decision", params)
}

export function trackInlineSignupSheetClosed(params: InlineSignupSheetClosedEvent["params"]): void {
  trackEvent("inline_signup_sheet_closed", params)
}

export function trackVerificationCodeResendFlowStarted(params: VerificationCodeResendFlowStartedEvent["params"]): void {
  trackEvent("verification_code_resend_flow_started", params)
}

export function trackVerificationCodeResendClicked(params: VerificationCodeResendClickedEvent["params"]): void {
  trackEvent("verification_code_resend_clicked", params)
}

export function trackVerificationCodeResent(params: VerificationCodeResendCompletedEvent["params"]): void {
  trackEvent("verification_code_resend_completed", params)
}
